// Общее состояние приложения по ключу (одно значение на вкладку браузера).
import { ref, type Ref } from 'vue';

const store = new Map<string, Ref<unknown>>();
export function useState<T>(key: string, init?: () => T): Ref<T> {
  if (!store.has(key)) store.set(key, ref(init ? init() : undefined));
  return store.get(key) as Ref<T>;
}
